import { render } from "./form-horizontal.vue?vue&type=template&id=1016008d"
import script from "./form-horizontal.vue?vue&type=script&lang=js"
export * from "./form-horizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__